module.exports = __webpack_public_path__ + "img/copy_outlined_64.72c6cc19.svg";